import React from "react";

export const DashboardLayout: React.FC<{}> = props => {
  return <div>{props.children}</div>;
};
